// audit-trail.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { AuditTrailService, AuditData } from '../services/audit-trail.service';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
})
export class AuditTrailComponent implements OnInit {
  @Input()
  documentId!: string;
  auditLogs!: AuditData[];
  

  constructor(private auditTrailService: AuditTrailService) {}

  ngOnInit() {
    this.loadAuditTrail();
  }

  loadAuditTrail() {
    this.auditTrailService.getAuditTrail(this.documentId).subscribe(
      (logs: AuditData[]) => (this.auditLogs = logs),
      error => console.error('Failed to load audit trail', error)
    );
  }
}
